import {ref, watch} from 'vue';
import {useInfiniteScroll} from '@vueuse/core';
import {PAGE_SIZE} from '@/enum/constant';

// 注意: 这里的钩子其实只为资讯列表进行服务, 因为包含了下拉刷新的判断.
// 如需服务其他列表, 需要删减逻辑
const useScrollList = <T, P={[key: string]: any}>(
  props: {
    getListFunc: (
      pager: ReqPager,
      params: P,
      nativeKey?: string,
      useNative?: boolean,
      type?: 'immediate' | 'await' | 'manual'
    ) => any;
    pageSize?: number;
    params: P;
    useNative?: boolean;
    listKey?: string;
    nativeKey?: string;
  }
) => {
  const {
    getListFunc,
    pageSize = PAGE_SIZE,
    params,
    useNative = false,
    listKey = 'list',
    nativeKey = 'list'
  } = props;
  const current = ref<number>(1);// 记录翻页页码
  const hasMore = ref<boolean>(true);// 记录列表是否还有数据
  const isLoading = ref<boolean>(false);// 是否正在加载下一页数据
  const listData = ref<{ [key: string]: T[] | any }>({
    [listKey]: []
  });

  // 初始化第一次请求列表数据
  // 使用native数据
  const {
    data,
    execute: firstPageRefetch,
    isFetching: firstPageFetching,
    isFinished: firstPageFinished,
    error: firstPageError
  } = getListFunc({
    pageSize,
    current: 1,
  }, params, nativeKey, useNative);
  watch(firstPageFinished, () => {
    if (firstPageFinished.value && !firstPageError.value) {// 首屏数据加载成功且没有出错, 列表重新赋值
      listData.value = data.value;
      current.value = 1;
      hasMore.value = data.value!.pager?.hasMore;
    }
  });

  // 列表翻页
  const scrollBox = ref<HTMLDivElement>();
  useInfiniteScroll(scrollBox, async () => {
    // 1. 没有更多数据时 2. 首页正在加载时 不请求下一页数据
    if (!hasMore.value || firstPageFetching.value) {
      return;
    }
    isLoading.value = true;
    const {data} = await getListFunc({
      current: ++current.value,
      pageSize: 25// 默认一页为 25 条
    }, params, '', false, 'await');
    isLoading.value = false;
    listData.value?.[listKey].push(...data.value![listKey]!);

    // eslint-disable-next-line
    hasMore.value = data.value!.pager?.hasMore!;
  }, {distance: 1500});// 开始加载时 距离底部的距离

  return {
    data,
    firstPageRefetch,
    firstPageError,
    firstPageFetching,
    firstPageFinished,
    scrollBox,
    isLoading,
    listData
  };
};

export default useScrollList;
